export default {
    SIGN_UP_USER: {
        link: '/authentication/signup/user',
        title: 'Création de profil organisateur',
    },
    SIGN_UP_ORGANISATION: {
        link: '/authentication/signup/organisation',
        title: 'Création d\'organisation',
    },
    SIGN_UP_FINISH: {
        link: '/authentication/signup/finish',
        title: 'Création de compte organisateur',
    },
    SIGN_UP_EXISTING: {
        link: '/authentication/signup/existing',
        title: 'Compte existant',
    },
    SIGN_IN: {
        link: '/authentication/signin',
        title: 'Connexion',
    },
    SIGN_IN_FORGOT: {
        link: '/authentication/signin/forgot',
        title: 'Mot de passe oublié',
    },
    SIGN_IN_FORGOT_FINISH: {
        link: '/authentication/signin/forgot/finish',
        title: 'Mot de passe oublié',
    },
    RECOVER: {
        link: '/authentication/recover',
        title: 'Réinitialisation de mot de passe',
    },
};
